var React = require('react');

function Water (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"w","clipPath":"url(#clip0_2349_22693)","key":0},React.createElement("path",{"id":"Vector","d":"M0.558115 0H23.4434C23.6428 0 23.8286 0.106557 23.927 0.281421C24.0253 0.456284 24.0226 0.669399 23.9188 0.84153L12.4761 19.8552C12.3751 20.0219 12.1947 20.1257 12.0007 20.1257C11.8068 20.1257 11.6237 20.0246 11.5253 19.8552L0.0799734 0.844262C-0.0238517 0.672131 -0.026584 0.459016 0.0717767 0.284153C0.170137 0.106557 0.35593 0 0.558115 0ZM22.4598 1.11202H1.54172L12.0007 18.4918L22.4598 1.11202Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2349_22693"},React.createElement("rect",{"width":"24","height":"20.1284","fill":"white"})))]);
}

Water.defaultProps = {"width":"24","height":"21","viewBox":"0 0 24 21","fill":"none"};

module.exports = Water;

Water.default = Water;
